const style = (theme) => ({
  root: {
    marginBottom: 100,
    [theme.mq.sm]: {
      marginBottom: 50,
    },
    '& .grid': {
      width: '100%',
      justifyContent: 'space-between',
      flexWrap: 'nowrap',
      [theme.mq.md]: {
        flexDirection: 'column',
      },
    },
  },
  gridRow: {
    flexDirection: 'row',
    [theme.mq.md]: {
      flexDirection: 'column',
    },
  },
  gridColumn: {
    flexDirection: 'column',
    alignItems: 'center',
    gap: 50,
  },
  detailsColLeft: {
    width: '40%',
    [theme.mq.md]: {
      width: '100%',
    },
    '& a': {
      color: theme.colors[2],
      textDecoration: 'underline',
    },
  },
  detailsColRight: {
    width: '60%',
    [theme.mq.md]: {
      width: '100%',
    },
    '& h3': {
      textAlign: 'center',
    },
  },
})

export default style
